import { render, staticRenderFns } from "./OfertaIndex.vue?vue&type=template&id=da0a8d20"
import script from "./OfertaIndex.vue?vue&type=script&lang=js"
export * from "./OfertaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports